import he from 'he';

import * as types from './types';
import * as htmlSanitize from 'src/helpers/htmlSanitize';

const find = (state, data, callback) => state.list.map(step => {
  if (step.id === data.id) {
    callback(step);
  }

  return step;
});

export const state = {
  quiz_id: '',
  list: [],
  active: {},
  preview: {},
};

export const mutations = {
  [types.STEPS_SET](state, { steps }) {
    state.list = htmlSanitize.stepList(steps);
    state.active = steps[0];
  },
  [types.STEP_ADD](state, { step }) {
    step.sanitized_title = htmlSanitize.text(step.title);

    state.list.splice(step.position, 0, step);
  },
  [types.STEP_REMOVE](state, index) {
    state.list.splice(index, 1);
  },
  [types.STEP_SET_ACTIVE](state, { step }) {
    step.sanitized_title = htmlSanitize.text(step.title);

    state.active = step;
  },
  [types.STEP_UPDATE_TITLE](state, data) {
    find(state, data, (step) => {
      step.title = data.title;
      step.sanitized_title = htmlSanitize.text(data.title);
    });
  },
  [types.STEP_UPDATE_MULTIPLE_ANSWER](state, data) {
    find(state, data, (step) => {
      step.multiple_answers = data.multiple_answers;
    });
  },
  [types.STEP_UPDATE_FORM_HTML](state, data) {
    find(state, data, (step) => {
      step.form_html = he.decode(data.form_html);
    });
  },
  [types.STEP_UPDATE_ORIGINAL_FORM_HTML](state, data) {
    find(state, data, (step) => {
      step.original_form_html = data.original_form_html;
    });
  },
  [types.STEP_UPDATE_FORM_CUSTOMIZED](state, data) {
    find(state, data, (step) => {
      step.customized_form = data.customized_form;
    });
  },
  [types.STEP_UPDATE_REDIRECT_AUTOMATIC](state, data) {
    find(state, data, (step) => {
      step.redirect_automatic = data.redirect_automatic;
    });
  },
  [types.STEP_UPDATE_REDIRECT_URL](state, data) {
    find(state, data, (step) => {
      step.redirect_url = data.redirect_url;
    });
  },
  [types.STEP_UPDATE_REDIRECT_BUTTON_TEXT](state, data) {
    find(state, data, (step) => {
      step.redirect_button_text = data.redirect_button_text;
    });
  },
  [types.STEP_UPDATE_QUIZ_ID](state, quizId) {
    state.quiz_id = quizId;
  },
  [types.STEP_UPDATE_REDIRECT_EMAIL_SERVICE](state, data) {
    find(state, data, (step) => {
      step.redirect_email_service = data.redirect_email_service;
    });
  },
  [types.STEP_UPDATE_DESCRIPTION_VISIBILITY](state, data) {
    find(state, data, (step) => {
      step.description_visibility = data.description_visibility;
    });
  },
  [types.STEP_UPDATE_DESCRIPTION](state, data) {
    find(state, data, (step) => {
      step.description_text = data.description_text;
    });
  },
  [types.STEP_UPDATE_POSITIONS](state) {
    state.list = state.list.map((step, index) => {
      step.position = index;
      return step;
    });
  },
  [types.STEP_PUSH](state, { steps }) {
    state.list.splice(steps[0].position, 0, ...steps);
  },
  [types.STEP_UPDATE_WELCOME_ACTIVE](state, data) {
    find(state, data, (step) => {
      step.welcome_active = data.welcome_active;
    });
  },
  [types.STEP_UPDATE_WELCOME_OPTION](state, data) {
    find(state, data, (step) => {
      step.welcome_option = data.welcome_option;
    });
  },
  [types.STEP_UPDATE_TEXT_REQUIRED](state, data) {
    find(state, data, (step) => {
      step.required = data.required;
    });
  },
  [types.STEP_UPDATE_TEXT_SIZE](state, data) {
    find(state, data, (step) => {
      step.text_size = data.text_size;
    });
  },
  [types.STEP_UPDATE_TEXT_PLACEHOLDER](state, data) {
    find(state, data, (step) => {
      step.placeholder_text = data.placeholder_text;
    });
  },
  [types.STEP_UPDATE_NEXT_BUTTON_TEXT](state, data) {
    find(state, data, (step) => {
      step.next_button_text = data.next_button_text;
    });
  },
  [types.STEP_SET_PREVIEW](state, { step }) {
    state.preview = step;
  },
  [types.STEP_SET_STYLES](state, styles) {
    state.preview.styles = Object.assign({}, state.preview.styles, styles);
  },
  [types.STEP_UPDATE_STYLE](state, { item, rule, value }) {
    if (!state.preview.styles) {
      state.preview.styles = {};
    }

    if (!state.preview.styles[item]) {
      state.preview.styles[item] = { rules: {} };
    }
    state.preview.styles[item].rules[rule] = value;
  },
  [types.STEP_RESET_STATE](state) {
    state.quiz_id = '';
    state.list = [];
    state.active = {};
    state.preview = {};
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/step/mutations.js
 **/